// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryImage_root__Vh4JG","left":"CategoryImage_left__PBff-","right":"CategoryImage_right__1U_8Y"};